import { render } from "./SigninPage.vue?vue&type=template&id=6373ab37"
import script from "./SigninPage.vue?vue&type=script&lang=js"
export * from "./SigninPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__